import { render, staticRenderFns } from "./IncomePredict.vue?vue&type=template&id=9e62303a&scoped=true"
import script from "./IncomePredict.vue?vue&type=script&lang=js"
export * from "./IncomePredict.vue?vue&type=script&lang=js"
import style0 from "./IncomePredict.vue?vue&type=style&index=0&id=9e62303a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e62303a",
  null
  
)

export default component.exports